import { useForm } from "react-hook-form";
import SingleInput from "../../../components/SingleInput";
import { useStandardCall } from "../../../hooks/useStandardCall";
import { AppContext } from "../../../hooks/auth/useAppContext";
import { useContext, useEffect, useState } from "react";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
export function AnagraficaUser({ myProfile }) {
  const appContext = useContext(AppContext);
  const [statusForm, setStatusForm] = useState(null);
  const {
    register,
    handleSubmit,
    setValue,
    control,
    formState: { errors },
  } = useForm({mode:"onChange"});
  const stdCall = useStandardCall();
  const [resource, setResourse] = useState(TheApp.Res);

  const inputs = [
    {
      id: "FirstName",
      label: (resource["Form.FirstName"] ?? "Nome"),
      type: "text",
      defaultValue: myProfile.FirstName,
      validationSchema: {
        required: resource["Form.RequiredLabel"] ?? "Campo obbligatorio",
      },
      placeholder: (resource["Form.FirstNamePlaceholder"] ?? "Inserisci il tuo nome"),
      icon: "fa fa-user",
      layout: "col-lg-6",
    },
    {
      id: "LastName",
      label: (resource["Form.LastName"] ?? "Cognome"),
      type: "text",
      defaultValue: myProfile.LastName,
      validationSchema: {
        required: resource["Form.RequiredLabel"] ?? "Campo obbligatorio",
      },
      placeholder: (resource["Form.LastNamePlaceholder"] ?? "Inserisci il tuo cognome"),
      icon: "fa fa-user",
      layout: "col-lg-6",
    },
    {
      id: "Birthday",
      label: (resource["Form.Birthday"] ?? "Data di nascita"),
      type: "date",
      defaultValue: myProfile.Birthday,
      validationSchema: {
        required: resource["Form.RequiredLabel"] ?? "Campo obbligatorio",
        pattern: {
          value: /^\d{4}-\d{2}-\d{2}$/,
          message: (resource["Form.Pattern.Birthday"] ?? "Formato data non valido dd/mm/yyyy"),
        },
        validate: {
          futureDate: (value) => {
            const date = new Date(value);
            const today = new Date();
            return (date.getTime() > today.getTime()) ? ((resource["Form.Birthday.Future"] ?? "La data deve essere futura")) : true;
          }
        }
      },
      icon: "fa fa-calendar",
      layout: "col-lg-6",
    },
    {
      id: "BirthPlace",
      label: (resource["Form.BirthPlace"] ?? "Luogo di nascita"),
      type: "text",
      defaultValue: myProfile.BirthPlace,
      validationSchema: {
        required: resource["Form.RequiredLabel"] ?? "Campo obbligatorio",
      },
      placeholder: ( resource["Form.BirthPlacePlaceholder"] ??  "Inserisci il tuo luogo di nascita"),
      icon: "fa fa-map-marker",
      layout: "col-lg-6",
    },
    {
      id: "Sex",
      label: (resource["Form.Sex"] ?? "Sesso"),
      type: "select",
      isMulti: false,
      defaultValue:myProfile?.Sex ? {
        value: myProfile?.Sex,
        label:
          myProfile?.Sex === "M"
            ? ( resource["Form.Sex.M"] ?? "Maschio")
            : myProfile?.Sex === "F"
            ? ( resource["Form.Sex.F"] ?? "Femmina")
            : "",
      } : "",
      placeholder: (resource["Form.SexPlaceholder"] ?? "Seleziona il tuo sesso"),
      validationSchema: {
        required: resource["Form.RequiredLabel"] ?? "Campo obbligatorio",
      },
      options: {
        Items: [
          { Value: "M", Label: ( resource["Form.Sex.M"] ?? "Maschio") },
          { Value: "F", Label: ( resource["Form.Sex.F"] ?? "Femmina") },
        ],
      },
      layout: "col-lg-6",
    },
    {
      id: "AddressStreet",
      label: (resource["Form.Address"] ??  "Indirizzo"),
      type: "text",
      defaultValue: myProfile.AddressStreet,
      placeholder: (resource["Form.AddressPlaceholder"] ??  "Indirizzo di residenza"),
      icon: "fa fa-map-marker",
      layout: "col-lg-12 col-md-6",
    },
    {
      id: "AddressNumber",
      label: (resource["Form.HouseNumber"] ??  "Numero civico"),
      type: "text",
      defaultValue: myProfile.AddressNumber,
      placeholder: (resource["Form.HouseNumber"] ??  "Numero civico"),
      icon: "fa fa-map-marker",
      layout: "col-lg-4 col-md-6",
    },
    {
      id: "AddressTown",
      label: ( resource["Form.City"] ?? "Città"),
      type: "text",
      defaultValue: myProfile.AddressTown,
      placeholder: (resource["Form.CityPlaceholder"] ??  "Città di residenza"),
      icon: "fa fa-map-marker",
      layout: "col-lg-4 col-md-6",
    },
    {
      id: "AddressZip",
      label: (resource["Form.AddressZip"] ??  "CAP"),
      type: "text",
      defaultValue: myProfile.AddressZip,
      placeholder: (resource["Form.AddressZipPlaceholder"] ??  "CAP di residenza"),
      icon: "fa fa-map-marker",
      layout: "col-lg-4 col-md-6",
    },
    {
      id: "FiscalNumber",
      label: (resource["Form.FiscalNumber"] ??  "Codice Fiscale"),
      type: "text",
      defaultValue: myProfile.FiscalNumber,
      validationSchema: {
        pattern: {
          //regex for italian fiscal code
          value: /^[A-Z]{6}\d{2}[A-Z]\d{2}[A-Z]\d{3}[A-Z]$/i,
          message: (resource["Form.FiscalNumber.Pattern"] ?? "Codice fiscale non valido"),
        },
      },
      tooltip: {
        message: "Questo campo è utilizzato per...",
      },
      placeholder: (resource["Form.FiscalNumberPlaceholder"] ?? "Inserisci il tuo codice fiscale"),
      icon: "fa fa-id-card",
      layout: "col-lg-12 col-md-6",
    },
    {
      id: "fitp",
      label: ( resource["Form.FITPNumber"] ??  "N. Tessera FITP"),
      type: "text",
      defaultValue: myProfile.FITP,
      validationSchema: {
        pattern: {
          value: /^[0-9]*$/i,
          message: ( resource["Form.FITPNumber.Pattern"] ??  "Numero tessera FITP non valido"),
        },
      },
      placeholder: (resource["Form.FITPNumberPlaceholder"] ??  "Inserisci il numero della tua tessera"),
      icon: "fa fa-id-card",
      layout: "col-lg-6",
    },
    {
      id: "FITPExpireDate",
      label: ( resource["Form.FITPExpirationDate"] ?? "Scadenza tessera FITP"),
      type: "date",
      defaultValue: myProfile.FITPExpireDate,
      validationSchema: {
        pattern: {
          value: /^\d{4}-\d{2}-\d{2}$/,
          message: ( resource["Form.Pattern.Birthday"] ?? "Formato data non valido dd/mm/yyyy"),
        },
      },
      placeholder: (resource["Form.FITPExpirationDatePlaceholder"] ??  "Inserisci il numero della tua tessera"),
      icon: "fa fa-calendar",
      layout: "col-lg-6",
    },
  ];


  async function updateProfile(data) {
    //console.log(data);
    const { Sex, ...restData } = data;
    const img = myProfile.ImageProfile;
    const rq = {
      myProfile: {
        ...restData,
        ImageProfile: img,
        Sex: Sex.value,
      },
    };
    appContext._setters._setLoading(true);
    stdCall.post("app/updateprofile", rq, (rs) => {
      if (rs.Success) {
        //update profile
        const sub = appContext.userSession.userData.myProfile.Subscriptions;
        const msg = appContext.userSession.userData.myProfile.MessagesCount;
        const newProfile = {
          ...appContext.userSession.userData.myProfile,
          ...rs.myProfile,
          MessagesCount: msg,
          Subscriptions: sub,
        };
        appContext._setters._setProfile(newProfile);
        setStatusForm({
          status: true,
          success: true,
          message: resource["Form.UpdateProfile.Success"] ?? "Profilo aggiornato correttamente",
        });
      } else {
        setStatusForm({
          status: true,
          message: resource["Form.GenericError"] ?? `Si è verificato un errore, riprova più tardi.`,
          success: false
        });
      }
    }).catch(error => {
      setStatusForm({
        status: true,
        message: resource["Form.GenericError"] ?? `Si è verificato un errore, riprova più tardi.`,
        success: false
      });
    })
      .finally(() => {
        appContext._setters._setLoading(false);

      });
  }

  useEffect(() => {
    if (statusForm) {
      if (statusForm?.success) {
        console.log("success");
        const toasts = toast.success(statusForm?.message);
      }
      if (!statusForm?.success) {
        console.log("fail");
        const toasts = toast.error(statusForm?.message);
      }
    }
  }, [statusForm]);


  useEffect(() => {
    setResourse(TheApp.Res[TheApp.Locale]);
  }, [resource]);

  return (
    <div className="wrapper-form">
      <form onSubmit={handleSubmit(updateProfile)}>
        <div className="row">
          {inputs.map((input, index) => {
            return (
              <SingleInput
                key={input.id}
                errors={errors}
                register={register}
                control={control}
                setValue={setValue}
                {...input}
              />
            );
          })}
        </div>
        <input value={( resource["Form.Save"] ?? "Salva")} type="submit" className="btn primary" />
      </form>
    </div>
  );
}
